import { render, staticRenderFns } from "./wisdomTraining.vue?vue&type=template&id=4c127e27&scoped=true&"
import script from "./wisdomTraining.vue?vue&type=script&lang=js&"
export * from "./wisdomTraining.vue?vue&type=script&lang=js&"
import style0 from "./wisdomTraining.vue?vue&type=style&index=0&id=4c127e27&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c127e27",
  null
  
)

export default component.exports